var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 218.74 135.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#761442;}.cls-3{fill:#8d1a51;}.cls-4{fill:#dc2e81;}.cls-5{opacity:0.63;}.cls-5,.cls-9{mix-blend-mode:overlay;}.cls-6{fill:url(#Degradado_sin_nombre_107);}.cls-7{fill:url(#Degradado_sin_nombre_107-2);}.cls-8{fill:url(#Degradado_sin_nombre_107-4);}.cls-9{fill:none;stroke-linejoin:bevel;stroke-width:0.49px;stroke:url(#Degradado_sin_nombre_100);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_107",
    x1: 236.05,
    y1: -422.23,
    x2: 95.94,
    y2: -246.05,
    gradientTransform: "matrix(0.99, 0.15, -0.15, 0.99, -89.39, 363.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_107-2",
    x1: 226.81,
    y1: -429.58,
    x2: 86.71,
    y2: -253.39,
    xlinkHref: "#Degradado_sin_nombre_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_107-4",
    x1: 253.35,
    y1: -408.48,
    x2: 113.24,
    y2: -232.29,
    xlinkHref: "#Degradado_sin_nombre_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_100",
    x1: 52.45,
    y1: -317.67,
    x2: 235.25,
    y2: -317.67,
    gradientTransform: "matrix(0.99, 0.15, -0.15, 0.99, -89.39, 363.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.35 21.38 14.13 135.17 0.12 128.84 202.34 15.04 216.35 21.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "202.34 15.04 0.12 128.84 2.5 113.79 204.72 0 202.34 15.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "202.34 15.04 0.12 128.84 2.5 113.79 204.72 0 202.34 15.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "204.72 0 218.74 6.34 216.35 21.38 202.34 15.04 204.72 0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.35 21.38 14.13 135.17 0.12 128.84 202.34 15.04 216.35 21.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.34 15.04 0.12 128.84 2.5 113.79 204.72 0 202.34 15.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.34 15.04 0.12 128.84 2.5 113.79 204.72 0 202.34 15.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "204.72 0 218.74 6.34 216.35 21.38 202.34 15.04 204.72 0"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.12,
    y1: 128.84,
    x2: 202.34,
    y2: 15.05
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset18);
export default __webpack_public_path__ + "static/media/asset18.119ca2a878a07a731f7218e2e5e36e7b.svg";
export { ForwardRef as ReactComponent };